(function() {

  class Video {
    constructor(element) {
      if(!element || element.classList.contains('u-module--initialized')) return;

      element.classList.add('u-module--initialized');

      this.element = element;

      this.breakpoints = {};

      // get a list of video switching points and links to the videos themselves 
      this.element.querySelectorAll('[data-src]').forEach(element => {
        let breakpointIdentifier = element.getAttribute('data-max-width')||'default';

        this.breakpoints[breakpointIdentifier] = this.breakpoints[breakpointIdentifier] || [];
        this.breakpoints[breakpointIdentifier].push({ src: element.getAttribute('data-src'), type: element.getAttribute('data-type') });
      });
      this.element.innerHTML = ''; // we clean up so that there is nothing superfluous 
      
      // run the handler and track the change in screen width
      this.responseVideo();
      this.resizer();
    }

    resizer() {
      window.addEventListener("resize", () => this.responseVideo());
    }

    responseVideo() {
      const widthNow = this.element.getAttribute('data-width-now') || null;
      const maxBreakpoint = Math.max(Object.keys(this.breakpoints).filter(key => key != 'default' && parseInt(key) >= document.body.clientWidth));
      const nowBreakpoint = maxBreakpoint || 'default'; // choose either the maximum value, if not, then the default 

      if(widthNow && widthNow == nowBreakpoint) return; // check if the video needs to be changed 
      let fallbackSrc = '';
      this.element.innerHTML = '';
      for (let index = 0; index < this.breakpoints[nowBreakpoint].length; index++) {
        const element = this.breakpoints[nowBreakpoint][index];
        let sourceElement = document.createElement('source');
        sourceElement.setAttribute('src', element.src);
        sourceElement.setAttribute('type', element.type);
        this.element.appendChild(sourceElement);
        fallbackSrc = element.src;
      }
      this.element.setAttribute('data-width-now', nowBreakpoint);
      // this.element.setAttribute('src', fallbackSrc);

      this.element.load();
    }
  }

  function initAll(parent) {
    const elements = parent.querySelectorAll('.u-video__player');

    for (const element of elements) {
      new Video(element)
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('overlay-content-ready', function () {
    initAll(document.querySelector('.u-overlay__content'));
  });

})();